var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cate-header-wrapper",class:{ 'trans-open': _vm.transOpen, 'trans-show': _vm.transShow, 'pos-sticky': _vm.posSticky }},[_c('h1',{staticClass:"title",domProps:{"textContent":_vm._s(_vm.title)}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }